const MuiTableCell = {
    styleOverrides: {
        head: {
            overflowWrap: 'break-word'
        }
    }
};
export { MuiTableCell };

//# sourceMappingURL=table-cell.js.map